import React from "react";
import Select from "react-select";
import { Controller, Control, FieldErrors } from "react-hook-form";

import "./style.scss"
import styles from './SelectDropdown.module.scss';
import block from 'bem-css-modules';
import { IFieldDropdown } from "./SelectDropdown.types";

import { sanitizeContent as s } from "../../../../util/functions";

const SelectDropdown = (props: { fieldData: IFieldDropdown, errors: FieldErrors, control: Control }) => {
  const {
    fieldData: {
      title,
      label,
      placeholder,
      options,
      validationText,
      settings: [{
        required
      }],
    },
    errors,
    control
  } = props;
  
  const b = block(styles);
  
  return (
    <div className={b()}>
      {title && (
        <h3 className={b("title")} dangerouslySetInnerHTML={{ __html: s(title) }} />
      )}

      <Controller
        name={label}
        control={control}
        rules={{ required: required }}
        render={({ field }) => (
          <Select
            options={options}
            onChange={val => field.onChange(val?.value)}
            value={options.find(option => option.value === field.value)}
            className={b("select")}
            classNamePrefix={`react-select`}
            placeholder={placeholder}
          />
        )}
      />

      {errors[label] && (
        <div className={b("error")} dangerouslySetInnerHTML={{ __html: s(validationText) }} />
      )}
    </div>
  )
}

export default SelectDropdown;